export default __webpack_public_path__ + "locales/lo-LA/PrivacyPage.json?hash=63341c60a44f1b9436ce6ce3a2f51dfc";